export default {
    init(vue) {
        return {
            alipayManagerOrdersSynctrade(data) {
                return vue.$http({
                    method: 'PUT',
                    url: `/api/v1/alipay/manager/orders/synctrade`,
                    data,
                })
            },
            kqManagerOrdersSynctrade(data) {
                return vue.$http({
                    method: 'GET',
                    url: `/api/v1/kuaiqian/manager/trades/${data.id}/status`
                })
            },
            wechatpayOrdersSynctrade(data) {
                return vue.$http({
                    method: 'PUT',
                    url: `/api/v1/wechatpay/manager/orders/synctrade`,
                    data,
                })
            },
            alipayManagerPretradesSync(data) {
                return vue.$http({
                    method: 'PUT',
                    url: `/api/v1/alipay/manager/pretrades/sync`,
                    data,
                })
            },
            getAlipayManagerPretrades(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/pretrades',
                    data,
                })
            },
            getDouyinpayPrePayorder(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/douyinpay/manager/tgdrama/prePayorder',
                    data,
                })
            },
            getDouyinPayManagerPretrades(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/douyinpay/manager/pretrades',
                    data,
                })
            },
            getAdchannelManagerRules(data) {
                return vue.$http({
                    method: 'GET',
                    url: '/api/v1/adchannel/manager/rules',
                    data,
                })
            },
            getAdchannelManagerRulesReset(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/adchannel/manager/rules/reset',
                    data,
                })
            },
            getManagerRecords(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/customerTel/manager/records',
                    data,
                })
            },
            getrefundFailLogs(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/refundFailLogs',
                    data,
                })
            },
            getUserComplaints(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/service/complaints',
                    data,
                })
            },
            getManagerComplaints(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/wechatpay/manager/complaints',
                    data,
                })
            },
            getManagerComplaintsAL(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/complains',
                    data,
                })
            },
            handleTk(data) {
                return vue.$http({
                    method: 'PUT',
                    url: `/api/v1/wechatpay/manager/complaints/${data.complaint_id}/refund/${data.out_trade_no}`,
                })
            },
            getManagerOrders(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/easyorders/manager/orders',
                    data,
                })
            },
            getManagerTrades(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/wechatpay/manager/trades',
                    data,
                })
            },
            getManagerTradesKQ(data) {
                return vue.$http({
                    method: 'GET',
                    url: '/api/v1/kuaiqian/manager/trades',
                    params: data,
                })
            },
            getManagerTradesAL(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/trades',
                    data,
                })
            },
            getManagerTradesTG(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/douyinpay/manager/tgdrama/payorder',
                    data,
                })
            },
            alInfluxDBQuery(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/influxDB/query',
                    data,
                })
            },
            getManagerTradesDY(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/douyinpay/manager/trades',
                    data,
                })
            },
            getMembers(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/equitymember/manager/members',
                    data,
                })
            },
            getEquityMember(params) {
                return vue.$http({
                    method: 'GET',
                    url: '/api/v1/common/dict',
                    params,
                })
            },
            handleEquityStatus(data) {
                return vue.$http({
                    method: 'PUT',
                    url: `/api/v1/equitymember/manager/members/${data.id}/equity/${data.elogid}`,
                    data,
                })
            },
            handleManagerRetryRecharge(data) {
                return vue.$http({
                    method: 'POST',
                    url: `/api/v1/equitymember/manager/retryRecharge`,
                    data,
                })
            },
            handleOrderStatus(data) {
                return vue.$http({
                    method: 'PUT',
                    url: `/api/v1/easyorders/manager/orders/${data.id}/status`,
                    data,
                })
            },
            deletePlan(id) {
                return vue.$http({
                    method: 'DELETE',
                    url: `/api/v1/admanager/plan/${id}`,
                })
            },
            saveYdTaskItem(data) {
                return vue.$http({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/yd/pages/quest/save',
                    data: data
                })
            },
            getYdTransactNumTopList(params) {
                return vue.$http({
                    method: 'GET',
                    url: '/yd/pages/quest/listTop',
                    params: params
                })
            },
            setFillInStandBy(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/setFillInStandBy',
                    data: data
                })
            },
            getPayAccountRules() {
                return vue.$http({
                    method: 'GET',
                    url: '/api/v1/adchannel/manager/payaccountrules'
                })
            },
            reloadAccountMapping() {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/reloadAccountMapping'
                })
            },
            getAgreementOrdersAL(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/agreements',
                    data,
                })
            },
            activeALAgreementsAnalysis() {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/alipay/manager/analysis'
                })
            },
            getWLDSStatics() {
                return vue.$http({
                    method: 'GET',
                    url: '/api/v1/alipay/manager/statics'
                })
            },
            getAgreementOrdersKQ(data) {
                return vue.$http({
                    method: 'GET',
                    url: '/api/v1/kuaiqian/manager/binds',
                    params: data,
                })
            },
            getKQStatics() {
                return vue.$http({
                    method: 'GET',
                    url: '/api/v1/kuaiqian/manager/statics'
                })
            },
            getAgreementOrdersTG(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/douyinpay/manager/tgdrama/agreement',
                    data,
                })
            },
            getAgreementPayOrders(id) {
                return vue.$http({
                    method: 'GET',
                    url: `/api/v1/alipay/manager/agreements/${id}/payorders`,
                })
            },
            getKuqiQianBindStatus(id) {
                return vue.$http({
                    method: 'GET',
                    url: `/api/v1/kuaiqian/manager/binds/${id}/status`,
                })
            },
            getAgreementStatus(id) {
                return vue.$http({
                    method: 'GET',
                    url: `/api/v1/alipay/manager/agreements/${id}/status`,
                })
            },
            agreementPay(id) {
                return vue.$http({
                    method: 'POST',
                    url: `/api/v1/alipay/manager/agreements/${id}/pay`,
                })
            },
            agreementPayTG(id) {
                return vue.$http({
                    method: 'POST',
                    url: `/api/v1/douyinpay/manager/tgdrama/agreements/${id}/pay`,
                })
            },
            agreementPrePayNotifyTG(id) {
                return vue.$http({
                    method: 'POST',
                    url: `/api/v1/douyinpay/manager/tgdrama/agreements/${id}/prePayNotify`,
                })
            },
            handleCommonOrderStatus(data) {
                return vue.$http({
                    method: 'PUT',
                    url: `/api/v1/commonorder/manager/orders/${data.id}/status`,
                    data,
                })
            },
            getCommonOrders(data) {
                return vue.$http({
                    method: 'POST',
                    url: '/api/v1/commonorder/manager/orders',
                    data,
                })
            },
            getMemberTypes() {
                return vue.$http({
                    method: 'GET',
                    url: '/api/v1/equitymember/manager/membertype'
                })
            }
        }
    }
}
